<script>
import { debounce } from 'debounce'
import { authComputed } from '@state/helpers'

export default {
  name: 'TopMenu',
  components: {},
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchTerm: '',
    }
  },
  computed: {
    unreadNotificationsCounter() {
      let unread = 0
      for (var i = this.notifications.length - 1; i >= 0; i--) {
        if (this.notifications[i].read_at == null) {
          unread++
        }
      }
      return unread
    },
    ...authComputed,
  },
  methods: {
    showUserEdit() {
      this.$emit('show-user-edit')
    },
    showNotificationsDrawer(e) {
      this.$emit('show-notifications-drawer', e)
    },
    search: debounce(async function search() {
      this.$emit('search', {
        searchTerm: this.searchTerm,
      })
    }, 500),
  },
}
</script>

<template>
  <div
    class="fixed top-0 w-full z-navbar bg-blue-lightest h-28 px-10 py-7 flex justify-between"
  >
    <div class="flex flex-grow justify-between max-w-5xl">
      <router-link
        :to="{
          name: 'company',
          params: { companyId: currentUser.default_company_id },
        }"
      >
        <svg
          id="Layer_1"
          with="222"
          height="54"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1770.61 431"
        >
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="5381.91"
              y1="-1375.4"
              x2="5696.21"
              y2="-1080.48"
              gradientTransform="translate(-5146.5 2460.75)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stop-color="#02648b" />
              <stop offset="1" stop-color="#66cdf1" />
            </linearGradient>
          </defs>
          <g>
            <path
              style="fill: #02648b;"
              d="M798.18,1284.63c-4.27,0-6.4-1.77-8.18-5.33l-44.83-87.88L732,1216.68v60.84c0,4.62-2.49,7.11-7.11,7.11H690.73c-4.62,0-7.11-2.49-7.11-7.11V1042.7c0-4.63,2.49-7.12,7.11-7.12h34.16c4.62,0,7.11,2.49,7.11,7.12v92.5l54.8-94.28c1.78-3.2,4.26-5.34,8.18-5.34h37.36c5.33,0,7.82,3.92,5,8.54L776.83,1150.5l64.4,126c2.49,4.63.36,8.18-5.33,8.18Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #02648b;"
              d="M1033.72,1035.58c5.34,0,7.83,3.56,5.69,8.19L974.3,1191.42v86.1c0,4.62-2.49,7.11-7.11,7.11H933c-4.62,0-7.11-2.49-7.11-7.11v-86.1l-65.11-147.65c-2.14-4.63.35-8.19,5.69-8.19h35.58c4.27,0,6.76,2.14,8.18,5.7l39.85,91.43L990,1041.28c1.42-3.56,3.91-5.7,8.18-5.7Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #02648b;"
              d="M1207.7,1035.58c3.56,0,5.7,2.14,5.7,5.7v237.66c0,3.56-2.14,5.69-5.7,5.69h-28.1c-3.2,0-5-1.42-6.41-4.62l-66.88-135.91v134.84c0,3.56-1.78,5.69-5.7,5.69h-33.44c-3.56,0-5.7-2.13-5.7-5.69V1041.28c0-3.56,2.14-5.7,5.7-5.7h28.1c3.21,0,5,1.43,6.41,4.63l66.89,135.91V1041.28c0-3.56,1.78-5.7,5.69-5.7Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #02648b;"
              d="M1249,1041.28c0-3.56,1.78-5.7,5.7-5.7h85.38c33.45,0,51.24,18.15,51.24,51.59V1233.4c0,33.44-17.79,51.23-51.24,51.23h-85.38c-3.92,0-5.7-1.77-5.7-5.69Zm81.12,196.39c9.25,0,14.23-4.62,14.23-14.23V1097.13c0-9.6-5-14.58-14.23-14.58h-32.73v155.12Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #02648b;"
              d="M1520.81,1041.28c0-3.56,2.14-5.7,5.7-5.7h36.64c4.27,0,6,2.14,6,5.7v237.66c0,3.56-1.78,5.69-6,5.69h-36.64c-3.56,0-5.7-2.13-5.7-5.69V1184.3h-45.54v94.64c0,3.56-2.13,5.69-5.69,5.69h-36.65c-4.26,0-6-2.13-6-5.69V1041.28c0-3.56,1.79-5.7,6-5.7h36.65c3.56,0,5.69,2.14,5.69,5.7v96.06h45.54Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #02648b;"
              d="M1740,1035.58a7.14,7.14,0,0,1,7.11,7.12v190.7c0,33.44-17.79,51.23-51.23,51.23H1656c-33.44,0-51.23-17.79-51.23-51.23V1042.7a7.14,7.14,0,0,1,7.11-7.12h34.16a7.15,7.15,0,0,1,7.12,7.12v180.74c0,9.61,5,14.23,14.23,14.23h18.5c9.25,0,14.23-4.62,14.23-14.23V1042.7a7.14,7.14,0,0,1,7.12-7.12Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #02648b;"
              d="M1925.36,1134.85c0,13.16-9.6,23.12-22.41,25.26v.71c12.81,2.14,22.41,12.1,22.41,25.26v47.32c0,33.44-18.14,51.23-51.59,51.23h-85.38c-3.56,0-5.7-2.13-5.7-5.69V1041.28c0-3.92,2.14-5.7,5.7-5.7h85.38c33.45,0,51.59,17.79,51.59,51.24Zm-45.18-40.21c0-9.25-4.63-14.23-14.23-14.23h-39.14V1137H1866c9.25,0,14.23-5,14.23-13.87Zm0,103.54c0-9.25-4.63-14.23-14.23-14.23h-39.14v55.85H1866c9.25,0,14.23-4.62,14.23-14.23Z"
              transform="translate(-154.75 -996.38)"
            />
          </g>
          <g>
            <path
              style="fill: #66cdf1;"
              d="M683.62,1390v-51.19H698.7q7.9,0,12.36,3.51t4.45,10.48a12.84,12.84,0,0,1-1.62,6.49,10,10,0,0,1-4.85,4.24,9.09,9.09,0,0,1,6,4.11A14,14,0,0,1,717,1375q0,7.35-4.2,11.15t-12,3.79Zm10-29.57h5.52a6.37,6.37,0,0,0,4.69-1.78,6.85,6.85,0,0,0,1.64-4.92c0-2.39-.57-4.15-1.69-5.27a7,7,0,0,0-5.1-1.67h-5.06Zm0,7V1382h7.06a6,6,0,0,0,4.73-1.76A7.63,7.63,0,0,0,707,1375a10,10,0,0,0-1.34-5.62,4.82,4.82,0,0,0-4.29-2Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M737.38,1360.73h.21l8.54-21.94H757l-14.63,33V1390h-10v-18.84L718,1338.79h10.94Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M787,1371.59V1390h-10v-51.19h17.8c5.1,0,9.14,1.51,12.09,4.53s4.43,7,4.43,11.87-1.48,8.88-4.45,11.89-7,4.51-12.07,4.51Zm0-8h7.78a5.63,5.63,0,0,0,4.88-2.36,10,10,0,0,0,1.69-6,10.48,10.48,0,0,0-1.67-6.08,5.57,5.57,0,0,0-4.9-2.41H787Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M827.67,1369.62V1390h-10v-51.16h16.7q7.56,0,11.86,4t4.31,11.1a13,13,0,0,1-1.79,6.91,12.63,12.63,0,0,1-5.24,4.62,9.82,9.82,0,0,1,5.68,4.43,15.6,15.6,0,0,1,1.74,7.74v3.62a22.41,22.41,0,0,0,.49,4.51,6.17,6.17,0,0,0,1.72,3.5v.74H842.83a5.72,5.72,0,0,1-1.55-3.65,42,42,0,0,1-.32-5.17v-3.48a9.86,9.86,0,0,0-1.56-6,5.27,5.27,0,0,0-4.48-2.11Zm0-8h6.68a5.74,5.74,0,0,0,4.64-1.86,7.94,7.94,0,0,0,1.59-5.31,9,9,0,0,0-1.59-5.59,5.44,5.44,0,0,0-4.6-2.08h-6.72Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M893,1371.59q0,9-4.89,14.07t-13,5.06q-8.13,0-13-5.06t-4.85-14.07v-14.34q0-9,4.85-14.08t12.94-5.12q8.08,0,13,5.12t4.92,14.08Zm-10-14.45q0-5.51-2-8.31a6.91,6.91,0,0,0-5.94-2.8,6.77,6.77,0,0,0-5.91,2.79c-1.31,1.85-2,4.63-2,8.32v14.46c0,3.71.66,6.5,2,8.35a7.64,7.64,0,0,0,11.81,0c1.36-1.85,2-4.64,2-8.35Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M917.54,1338.79h10v35.58q0,7.53-4.23,11.94a14.2,14.2,0,0,1-10.68,4.41q-6.95,0-11-3.94t-3.92-11.6l.11-.21h9.74q0,4,1.42,5.91a4.42,4.42,0,0,0,3.67,1.86,4.2,4.2,0,0,0,3.51-2.22,11.1,11.1,0,0,0,1.45-6.15Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M962.41,1367.51H945.22V1382h20.21v8H935.19v-51.19h30.17v8H945.22v12.76h17.19Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1002.74,1373.49l.1.21q.07,8.44-4,12.73t-12,4.29q-7.95,0-12.69-4.87t-4.75-13.8v-15.29q0-8.91,4.59-13.81t12.29-4.9q8.16,0,12.32,4.36t4.31,12.9l-.1.21h-9.64q.21-5-1.37-7.27t-5.52-2.22a5.86,5.86,0,0,0-5.17,2.64c-1.2,1.76-1.79,4.42-1.79,8V1372q0,5.42,1.91,8.06a6.5,6.5,0,0,0,5.61,2.64c2.41,0,4.1-.7,5.05-2.09s1.36-3.78,1.24-7.16Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1038,1346.77h-11.54V1390h-10v-43.21H1005v-8h33Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1094.51,1390h-10v-21.2h-15.9V1390h-10v-51.19h10v22h15.9v-22h10Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1129.46,1367.51h-17.19V1382h20.22v8h-30.24v-51.19h30.17v8h-20.15v12.76h17.19Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1147.71,1382h18.71v8h-28.73v-51.19h10Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1181.43,1371.59V1390h-10v-51.19h17.79q7.66,0,12.1,4.53t4.43,11.87q0,7.38-4.45,11.89t-12.08,4.51Zm0-8h7.77a5.65,5.65,0,0,0,4.89-2.36,10.08,10.08,0,0,0,1.69-6,10.48,10.48,0,0,0-1.67-6.08,5.59,5.59,0,0,0-4.91-2.41h-7.77Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1222.6,1390h-9.95v-51.19h9.95Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1266.73,1390h-10l-15.65-32.73-.21.07V1390h-10v-51.19h10l15.65,32.7.21-.07v-32.63h10Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #66cdf1;"
              d="M1308.43,1382.39a18.38,18.38,0,0,1-6.22,5.82,20.08,20.08,0,0,1-10.52,2.51q-8.22,0-13.2-4.82t-5-13.71v-15.61q0-8.82,4.8-13.68t12.71-4.85q8.51,0,12.76,4.16t4.43,11.92l-.07.22h-9.39q-.1-4.33-1.91-6.33c-1.21-1.32-3.06-2-5.54-2a6.92,6.92,0,0,0-5.73,2.59q-2.08,2.58-2.08,7.86v15.7q0,5.38,2.1,8a7.35,7.35,0,0,0,6.09,2.59,9.26,9.26,0,0,0,4.42-.81,6.33,6.33,0,0,0,2.34-2.39v-9.18h-6.76v-7h16.74Z"
              transform="translate(-154.75 -996.38)"
            />
          </g>
          <rect
            style="fill: url(#linear-gradient);"
            x="154.75"
            y="996.38"
            width="431"
            height="431"
            rx="119.41"
            transform="translate(585.75 1427.38) rotate(-180)"
          />
          <g>
            <path
              style="fill: #fff;"
              d="M241.7,1189.69a53.46,53.46,0,0,0,12.93,33.1c14.44,16.48,34.1,18.1,41.22,18.1h7.58a56.63,56.63,0,0,0-19,32.88c-4.9,28.19,14.61,48.11,16.85,50.29A58.57,58.57,0,0,0,342,1340.46a57.18,57.18,0,0,0,19.16-3.28,58.33,58.33,0,0,0,38.59-52.06c.05-.79.08-1.43,0-44.28v-.21l41.53-.1c4.62.07,28.93-.6,45.35-21.16,2.53-3.17,15-20.13,11.61-42.75a59.23,59.23,0,0,0-36.62-45.85l13.85-13.87a7.32,7.32,0,1,0-10.36-10.35l-13.92,13.93,4.48-19.06a7.32,7.32,0,0,0-14.26-3.35l-6.81,29c-.06.24-.1.48-.14.72a56.84,56.84,0,0,0-32.12,17.54c-1,1.1-2,2.25-2.93,3.41l-.09-15.53V1133c-.26-6.61-2.42-23.42-16.78-36.51-5.29-4.83-16.57-13-32.53-13.23-3.82,0-23.68.44-37.77,16.84a49.5,49.5,0,0,0-11.55,28.1c0,.12,0,.23,0,.35l-.3,10.48-9.06-.24h-.4A51.51,51.51,0,0,0,256.13,1154,51,51,0,0,0,241.7,1189.69ZM358,1258.8a59.24,59.24,0,0,1-10.24-18l38.23,0v.11c0,17.79.06,29.71.06,36.51A60.14,60.14,0,0,1,358,1258.8Zm41.88-31.92L399.7,1199c0-3,0-5.58,0-7.67V1191l0-.25c0-.48,0-1-.06-1.44l0-3.52a48.08,48.08,0,0,1,12.76-31.06c8.18-8.77,19.19-13.82,30.22-13.85h.08c17.46,0,38.44,14.41,41.94,37.75,2.6,17.33-7.58,30.66-8.75,32.13-12.42,15.54-31,16.07-34.52,16Zm-95.44,33.4a87,87,0,0,0,57.81,61.45,44.06,44.06,0,0,1-51.34-7.55c-.68-.67-16.64-16.47-12.89-38.08A41.1,41.1,0,0,1,304.43,1260.28Zm28.5-19.45h.38a73.42,73.42,0,0,0,14.12,26.79,74.38,74.38,0,0,0,37.64,23.81,45,45,0,0,1-9.49,19.54,75.28,75.28,0,0,1-40.22-22,74.43,74.43,0,0,1-19.3-40.59A48.45,48.45,0,0,1,332.93,1240.83Zm-77.47-51.27c-.14-14,8-23.4,10.5-26a37.56,37.56,0,0,1,25.17-11l15.72.41H307a6.88,6.88,0,0,0,6.87-6.68l.49-17.16a35.63,35.63,0,0,1,8.27-20.05c10.08-11.74,24.33-12.14,27.1-12a36.16,36.16,0,0,1,23.5,9.64c10.72,9.76,12.12,22.82,12.29,26.77l.32,52.8c0,1.07,0,2.15,0,3.23l.05,9.65v11c0,6.24,0,11.78,0,16.77l-54.34.13-.2,0-34.72.05c-3.39.08-20.17-.22-31.72-13.4A40.36,40.36,0,0,1,255.46,1189.56Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #fff;"
              d="M354.22,1108.4a6.88,6.88,0,0,1,0,13.75A16.28,16.28,0,0,0,338,1138.41a6.88,6.88,0,0,1-13.76,0A30,30,0,0,1,354.22,1108.4Z"
              transform="translate(-154.75 -996.38)"
            />
            <path
              style="fill: #fff;"
              d="M442.81,1152.3a6.88,6.88,0,0,1,0,13.75,16.28,16.28,0,0,0-16.26,16.26,6.88,6.88,0,0,1-13.76,0A30,30,0,0,1,442.81,1152.3Z"
              transform="translate(-154.75 -996.38)"
            />
          </g>
        </svg>
      </router-link>
      <div class="topbar-item w-56 relative">
        <input
          v-model="searchTerm"
          type="text"
          name="search"
          class="input align-middle pl-10"
          @input="search"
        />
        <svg
          class="absolute left-0 top-0 mt-5 ml-4"
          xmlns="http://www.w3.org/2000/svg"
          width="16.187"
          height="16.142"
          viewBox="0 0 16.187 16.142"
        >
          <g transform="translate(17.622 0.071)">
            <path
              class="a"
              d="M-1.673,14.693l-3.6-3.615a6.9,6.9,0,0,0-1.2-9.689,6.9,6.9,0,0,0-9.688,1.2,6.9,6.9,0,0,0,1.2,9.689,6.9,6.9,0,0,0,8.554-.051l3.6,3.611a.809.809,0,0,0,1.14,0h0A.809.809,0,0,0-1.673,14.693ZM-10.7,12.12a5.3,5.3,0,0,1-5.316-5.283,5.3,5.3,0,0,1,5.284-5.316A5.3,5.3,0,0,1-5.421,6.8v.019A5.3,5.3,0,0,1-10.7,12.12Z"
              fill="#069BD7"
            />
          </g>
        </svg>
      </div>
      <div class="topbar-item">
        <router-link
          :to="{ name: 'user-page', params: { userId: currentUser.id } }"
          >Achievements</router-link
        >
      </div>
      <div class="topbar-item relative">
        <a href="" @click.prevent="showNotificationsDrawer">Notifications</a>
        <span
          v-if="unreadNotificationsCounter"
          class="absolute bg-blue-light rounded-lg w-55 h-55 inline-block leading-tight text-white text-center text-lg -ml-2 -mt-1"
          >{{ unreadNotificationsCounter }}</span
        >
      </div>
      <div class="topbar-item">
        <a class="cursor-pointer" @click="showUserEdit">Update Info</a>
      </div>
    </div>
    <div class="flex flex-grow justify-between max-w-2xs">
      <div class="topbar-item">
        <img
          :src="currentUser.image_url"
          class="rounded-full cursor-pointer post-avatar"
          @click="showUserEdit"
        />
      </div>
      <div class="topbar-item">
        <a href=""></a>
        <router-link :to="{ name: 'logout' }"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 882.35 1000"
            fill="#069bd7"
            height="17"
            width="15"
            class="inline-block -mt-1 mr-3"
          >
            <title>Kyndhub_Logout_Icon</title>
            <path
              d="M941.18,1000H323.53V941.18H882.35V58.82H323.53V0H941.18ZM411.76,806.29v-218H58.82V411.76H411.76v-218L718.06,500ZM117.65,529.41H470.59V664.29L634.88,500,470.59,335.71V470.59H117.65Z"
              transform="translate(-58.82)"
            /></svg
          >Logout</router-link
        >
      </div>
    </div>
  </div>
</template>
